// extracted by mini-css-extract-plugin
export default {"root":"styles_root__W+TB+","dataValue":"styles_dataValue__Dzhwt","dataLabel":"styles_dataLabel__NvfHW","dataGoal":"styles_dataGoal__22IXO"};